export const MERCH_COLLECTION_STATUSES = {
  draft: "draft",
  live: "live",
  comingSoon: "comingSoon",
  retired: "retired"
};

export const merchCollections = [
  {
    id: "identity",
    number: "Collection 001",
    title: "Identity",
    subtitle: "Premium streetwear inspired by automotive culture.",
    manifesto: "Designed around the belief that every build deserves an identity.",
    description: "Three designs. One visual language. Built to establish MyBuildID as more than app merchandise.",
    heroImage: null,
    status: MERCH_COLLECTION_STATUSES.live,
    releaseDate: null,
    featured: true,
    // Collection 001 standard: centered MyBuildID logo on front; product-specific artwork on back.
    productIds: [
      "identity-tee",
      "archive-tee",
      "scan-my-build-tee"
    ]
  }
];

export function getMerchCollectionById(collectionId) {
  return merchCollections.find((collection) => collection.id === collectionId) || null;
}

export function getFeaturedMerchCollection() {
  return merchCollections.find(
    (collection) => collection.featured && collection.status === MERCH_COLLECTION_STATUSES.live
  ) || null;
}
